import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {CfgARPaymentProcessorModel} from '../../../models/accountsReceivable/cfg-ar-payment-processor.model';
import {EnumPaymentProcessorModel} from '../models/enum-payment-processor.model';
import {WorkstationConfigurationModel} from '../../../models/configuration/workstation-configuration.model';
import {CfgArPaymentProcessorDeviceModel} from '../../../models/accountsReceivable/cfg-ar-payment-processor-device.model';
import {ARPaymentProcessorModel} from '../../../models/accountsReceivable/ARPaymentProcessorModel';
import {PaymentProcessorDeviceListModel} from '../models/payment-processor-device-list.model';
import {DataDoctorArPaymentProcessorModel} from '../../../models/accountsReceivable/data-doctor-ar-payment-processor.model';

@Injectable({
  providedIn: 'root'
})
export class PaymentProcessorConfigurationService {
  constructor(private http: HttpClient) {
  }

  getClients(): Observable<any[]> {
    let url: string;
    const method: string = 'payment-processor-configuration/tdo-clients';
    url = environment.TDOurl + method;
    return this.http.get<any>(url);
  }

  getClientLocations(tdocid: string): Observable<any[]> {
    let url: string;
    const method: string = 'payment-processor-configuration/tdo-clients-locations/' + tdocid;
    url = environment.TDOurl + method;
    return this.http.get<any>(url);
  }

  getPaymentProcessorList(locid: string): Observable<CfgARPaymentProcessorModel[]> {
    let url: string;
    const method: string = 'payment-processor-configuration/payment-processor-by-location/' + locid;
    url = environment.TDOurl + method;
    return this.http.get<CfgARPaymentProcessorModel[]>(url);
  }


  getPaymentProcessorARLocList(DoctorARLocId: string): Observable<CfgARPaymentProcessorModel[]> {
    let url: string;
    const method: string = 'payment-processor-configuration/payment-processor-by-ARlocation/' + DoctorARLocId;
    url = environment.TDOurl + method;
    return this.http.get<CfgARPaymentProcessorModel[]>(url);
  }

  getValPayPaymentProcessorARLocList(): Observable<DataDoctorArPaymentProcessorModel[]> {
    let url: string;
    const method: string = 'payment-processor-configuration/valpay-payment-processor-by-ARlocation/';
    url = environment.TDOurl + method;
    return this.http.get<DataDoctorArPaymentProcessorModel[]>(url);
  }

  getPaymentProcessorDevices(locid: string): Observable<PaymentProcessorDeviceListModel[]> {
    let url: string;
    const method: string = 'payment-processor-configuration/payment-processor-devices-by-location/' + locid;
    url = environment.TDOurl + method;
    return this.http.get<PaymentProcessorDeviceListModel[]>(url);
  }

  getPaymentProcessorDevice(paymentDeviceID: string): Observable<CfgArPaymentProcessorDeviceModel> {
    let url: string;
    const method: string = `payment-processor-configuration/payment-processor-device/${paymentDeviceID}`;
    url = environment.TDOurl + method;
    return this.http.get<CfgArPaymentProcessorDeviceModel>(url);
  }

  getPaymentProcessorTypeIsDevice(): Observable<ARPaymentProcessorModel[]> {
    let url: string;
    const method: string = 'payment-processor-configuration/payment-processor-types-isdevice/';
    url = environment.TDOurl + method;
    return this.http.get<ARPaymentProcessorModel[]>(url);
  }

  getPaymentProcessorTypes(): Observable<EnumPaymentProcessorModel[]> {
    let url: string;
    const method: string = 'payment-processor-configuration/payment-processor-types/';
    url = environment.TDOurl + method;
    return this.http.get<EnumPaymentProcessorModel[]>(url);
  }

  saveProcessor(processor: CfgARPaymentProcessorModel): Observable<CfgARPaymentProcessorModel> {
    return this.http.post<CfgARPaymentProcessorModel>('/api/payment-processor-configuration/save-processor/', processor);
  }

  saveProcessorDevice(processDevice: CfgArPaymentProcessorDeviceModel): Observable<CfgArPaymentProcessorDeviceModel> {
    return this.http.post<CfgArPaymentProcessorDeviceModel>('/api/payment-processor-configuration/save-processor-device/', processDevice);
  }

  getEnumValidValueItemsByValidValueName(ValidValueName: string): Observable<EnumPaymentProcessorModel[]> {
    return this.http.get<EnumPaymentProcessorModel[]>('/api/payment-processor-configuration/payment-processor-types/');
  }

  getWorkstations(locid: string): Observable<WorkstationConfigurationModel[]> {
    return this.http.get<WorkstationConfigurationModel[]>(`api/payment-processor-configuration/get-workstations/${locid}`);
  }

  // pairTriPosDevice(processor: CfgARPaymentProcessorModel): Observable<TriposCloudDevicePairResponseModel> {
  //   return this.http.post<TriposCloudDevicePairResponseModel>('/api/payment-processor-configuration/pair-tripos-lane/', processor);
  // }

  // unPairTriPosDevice(processor: CfgARPaymentProcessorModel): Observable<TriposCloudDevicePairResponseModel> {
  //   return this.http.post<TriposCloudDevicePairResponseModel>('/api/payment-processor-configuration/unpair-tripos-lane/', processor);
  // }

  // getTriPosLaneExists(processor: CfgARPaymentProcessorModel): Observable<TriposCloudDevicePairResponseModel> {
  //   return this.http.post<TriposCloudDevicePairResponseModel>('/api/payment-processor-configuration/get-tripos-lane-exists/', processor);
  // }
}
